import { render, staticRenderFns } from "./logcarshipviewout.vue?vue&type=template&id=90c2af38&scoped=true&"
import script from "./logcarshipviewout.vue?vue&type=script&lang=js&"
export * from "./logcarshipviewout.vue?vue&type=script&lang=js&"
import style0 from "./logcarshipviewout.vue?vue&type=style&index=0&id=90c2af38&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90c2af38",
  null
  
)

export default component.exports